import { render, staticRenderFns } from "./textMessage.vue?vue&type=template&id=7a012c80&scoped=true&"
import script from "./textMessage.vue?vue&type=script&lang=js&"
export * from "./textMessage.vue?vue&type=script&lang=js&"
import style0 from "./textMessage.vue?vue&type=style&index=0&id=7a012c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a012c80",
  null
  
)

export default component.exports